// Dane mapy hero D (paczka HD): trzy własne konta artysty, dziewięć publikacji, kadry.
//
// Źródło: `41-minimal-strona-glowna/D/src/01-hero.dc.html` (węzły z `--x/--y` dla układu poziomego
// i `--mx/--my` dla pionowego) i MAPA D, „Dane w mapie”. Dane przykładowe są STAŁĄ W KODZIE, nie
// słownikiem (tak samo jak edity w `LandingEditShowcase.tsx`); przez klucze idą tylko słowa, które
// różnią się między PL i EN: nazwa utworu, „dziś”, dni tygodnia i „{n} editów”.
//
// Konta: `@nocna.jazda` TikTok, `@zostan.chwile` Instagram, „Nocna Zmiana” YouTube. Utwór 2:48,
// seria 9 editów. Dziś = wtorek. Żadnych liczb odbioru.

import type { PlatformKey } from '../../lib/landingTree'

/** Klucz kadru generatora → plik w `frontend/public/kadry` (tabela `.bk.k-*` z 37b.css). */
export const KADR_FILE: Record<string, string> = {
  n2t1: 'nostalgia-02-przystanek-we-mgle-t01',
  n5t1: 'nostalgia-05-przejscie-wsrod-zieleni-t01',
  hf1: 'hyperpop-forest-t01',
  n3t1: 'nostalgia-03-latarnia-i-deszcz-t01',
  n1t3: 'nostalgia-01-mokry-chodnik-t03',
  n5t3: 'nostalgia-05-przejscie-wsrod-zieleni-t03',
  n4t3: 'nostalgia-04-ulica-o-zmierzchu-t03',
  n2t3: 'nostalgia-02-przystanek-we-mgle-t03',
}
export const kadrSrc = (key: string) => `/kadry/${KADR_FILE[key]}.jpg`

/** Punkt węzła w pikselach mapy: `v` = pion (358 × 300), `h` = poziom (720 × 520). */
export type MapPoint = { x: number; y: number }

/** Konto D: `v` / `h` = lewy górny róg węzła na osi awatara (środek awatara = y + promień). */
export const D_ACCOUNTS: { nick: string; pf: PlatformKey; kadr: string; v: MapPoint; h: MapPoint }[] = [
  { nick: '@nocna.jazda', pf: 'tt', kadr: 'n3t1', v: { x: 66, y: 142 }, h: { x: 466, y: 74 } },
  { nick: '@zostan.chwile', pf: 'ig', kadr: 'n5t1', v: { x: 179, y: 142 }, h: { x: 466, y: 246 } },
  { nick: 'Nocna Zmiana', pf: 'yt', kadr: 'hf1', v: { x: 292, y: 142 }, h: { x: 466, y: 418 } },
]

export type StopState = 'ok' | 'sch' | 'wt'

/**
 * Publikacje trzech kont D. `day` = indeks w `landing.hero.map.days` (pon = 0), `order` =
 * kolejność chronologiczna, w której przystanki wchodzą ruchem wejścia (co 100 ms od 1300 ms).
 * Stan wg reguły 50: pełna biała = wyszła, pełna przygaszona = zaplanowana, pierścień = czeka na zgodę.
 */
export const D_STOPS: { acc: 0 | 1 | 2; state: StopState; day: number; time: string; kadr: string; order: number; v: MapPoint; h: MapPoint }[] = [
  { acc: 0, state: 'ok', day: 0, time: '18:00', kadr: 'n2t1', order: 0, v: { x: 66, y: 212 }, h: { x: 548, y: 96 } },
  { acc: 0, state: 'sch', day: 2, time: '18:00', kadr: 'n3t1', order: 3, v: { x: 66, y: 252 }, h: { x: 632, y: 96 } },
  { acc: 0, state: 'sch', day: 4, time: '18:00', kadr: 'n1t3', order: 6, v: { x: 66, y: 290 }, h: { x: 700, y: 96 } },
  { acc: 1, state: 'ok', day: 1, time: '12:30', kadr: 'n5t1', order: 1, v: { x: 179, y: 220 }, h: { x: 536, y: 268 } },
  { acc: 1, state: 'sch', day: 3, time: '12:30', kadr: 'n5t3', order: 4, v: { x: 179, y: 260 }, h: { x: 620, y: 268 } },
  { acc: 1, state: 'sch', day: 5, time: '12:30', kadr: 'n4t3', order: 7, v: { x: 179, y: 296 }, h: { x: 704, y: 268 } },
  { acc: 2, state: 'wt', day: 1, time: '20:00', kadr: 'hf1', order: 2, v: { x: 292, y: 208 }, h: { x: 560, y: 440 } },
  { acc: 2, state: 'sch', day: 3, time: '20:00', kadr: 'n2t3', order: 5, v: { x: 292, y: 248 }, h: { x: 640, y: 440 } },
  { acc: 2, state: 'sch', day: 6, time: '20:00', kadr: 'n3t1', order: 8, v: { x: 292, y: 288 }, h: { x: 704, y: 440 } },
]

/** Pigułka utworu (lewy górny róg) i pigułka serii; etykieta „dziś”. */
export const D_TRACK: { v: MapPoint; h: MapPoint } = { v: { x: 0, y: 0 }, h: { x: 0, y: 240 } }
export const D_SERIES: { kadry: string[]; v: MapPoint; h: MapPoint } = { kadry: ['n2t1', 'n5t1', 'hf1'], v: { x: 114, y: 62 }, h: { x: 264, y: 246 } }
export const D_TODAY: { v: MapPoint; h: MapPoint } = { v: { x: 0, y: 222 }, h: { x: 592, y: 20 } }

/** Czas utworu i liczba editów w serii (dana przykładowa D, nie wynik). */
export const TRACK_TIME = '2:48'
export const SERIES_EDITS = 9

/** Fala utworu: 16 słupków, wysokość w % pola (klasy h1..h9 z 37.css: 12 … 100). */
export const TRACK_WAVE = [34, 58, 82, 100, 70, 46, 82, 92, 58, 34, 70, 100, 82, 46, 70, 34]
